var render = function render(){var _vm=this,_c=_vm._self._c;return _c('supply-demand',{attrs:{"type":"demand"}})
}
var staticRenderFns = []

export { render, staticRenderFns }